import { render, staticRenderFns } from "./UsergroupsOptions.vue?vue&type=template&id=58a1579e"
import script from "./UsergroupsOptions.vue?vue&type=script&lang=js"
export * from "./UsergroupsOptions.vue?vue&type=script&lang=js"
import style0 from "./UsergroupsOptions.vue?vue&type=style&index=0&id=58a1579e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports